import React from 'react';

const PhoneIcon: React.FC<{className?: string}> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.211-1.01-.58-1.386l-2.54-2.54a1.125 1.125 0 00-1.59 0L15 12.251a11.253 11.253 0 01-5.49-5.49l.564-.564a1.125 1.125 0 000-1.59l-2.54-2.54A1.125 1.125 0 006.372 1.875H5.25A2.25 2.25 0 003 4.125v2.625z" />
    </svg>
  );
};

export default PhoneIcon;
